import {
  BrowseSubscriptionPlanRequest,
  BrowseSubscriptionPlanResponse,
  PlanInterval,
  SubscriptionStatus,
} from '@aibees/shared/definition';
import { useBaseQuery } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';
import { PLAN_ROOT_ENDPOINT_UM } from '@aibees/shared/workspace/constants/endpoints';

export function useBrowseSubscriptionPlanApi(interval?: PlanInterval) {
  const wid = useWorkspace()?.id;

  return useBaseQuery<
    BrowseSubscriptionPlanRequest,
    BrowseSubscriptionPlanResponse
  >([useBrowseSubscriptionPlanApi.name, interval], {
    url: PLAN_ROOT_ENDPOINT_UM.replace(':wid', String(wid)),
    params: {
      status: SubscriptionStatus.ACTIVE,
      interval,
    },
  });
}
